<template>
  <div>
    <table :height="this.windowSize.height-8" :max-height="this.windowSize.height-8" style="position: absolute;"
           width="100%">
      <tr height="48px" max-height="48px">
        <ContenidoBase
            :EstadoBtn="EstadoBtn"
            :descripcion="'Imprime las Facturas de Clientes.'"
            :titulo="'Reporte de Facturas por Clientes'"
            @MethodAnular="anular"
            @MethodEliminar="remove"
            @MethodGuardar="save"
            @MethodImprimir="imprimirList"
            @MethodNuevo="newwnuevo"
            @abrirBarraTablaDinamica="abrirTabla"

        />
      </tr>
      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height-96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn
                        color="yellow accent-4"
                        small
                        @click.prevent="actualiza_tb_ver"
                    >
                      <i class="fa fa-eye" style="font-size: 25px;"> </i> ver
                    </v-btn
                    >
                    <v-btn
                        color="deep-purple accent-2"
                        dark
                        small
                        @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                    >
                      <i class="fa fa-print" style="font-size: 25px;"> </i>
                      Listado
                    </v-btn
                    >
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
                  :url="
                    $hostname + $hName + '/services/tipocliente/findalltipoclientes'
                  "
                  :nombre="'Tipo de Clientes'"
                  :headers="headers"
                  :slotname="'item.descripcion'"
                  :emitnombre="'emitReporteClientesCredito'"
                  :SeachNombre="'Búsqueda por descripcion '"
                  :slotlist="slotlist"
                /> -->
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height-96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">

            <!-- Formulario-Facturas a Creditos por Clientes -->
            <v-container>
              <v-card color="grey lighten-3">

                <v-toolbar
                    color="#BDBDBD"
                    dense
                    flat
                    style="border: 1px solid #000000;"
                >


                  <v-avatar size="45" tile>
                    <img
                        alt="Reporte"
                        src="@/assets/iconos_micromarket/custom-reports.png"
                    >
                  </v-avatar>


                  <span class="font-weight-light"
                        style="font-size: 20px;"> Reporte de Facturas por Clientes </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
                    color="grey darken-4"
                    fab
                    small
                    @click="cerrarmodalcuenta"
                  >
                   <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
                  </v-btn> -->
                </v-toolbar>

                <hr>

                <v-container style="border: 1px solid #000000;">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">


                        <!-- -----------------------------  desde  -->
                        <v-text-field
                            v-model="ClientesCredito.desde"
                            :rules="[$rules.required]"
                            dense
                            label="Desde:"
                            outlined
                            type="date"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px;"></i>
                          </template>

                        </v-text-field>

                        <!-- -----------------------------  Cliente  -->
                        <v-combobox
                            v-model="ClientesCredito.cliente"
                            :items="Rcliente"
                            autocomplete="off"
                            dense
                            item-text="codnom"
                            label="Cliente:"
                            no-filter
                            outlined
                            @blur="SelctCbClient"
                            @focus="cargarCliente"
                            @keyup="CbFilcliente"
                        >
                          <template slot="item" slot-scope="item">
                            <span style="display:none;">{{
                                item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                              }}</span>
                            <span
                                class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }}</span>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                            <span class="fontSize13 colorNombre"><b>{{ item.codigo }}</b> - {{ item.nombre }}</span>
                          </template>
                          <template v-slot:prepend>
                            <i
                                class="fa fa-user-circle-o"
                                style="font-size: 30px;"
                            ></i>
                          </template>
                        </v-combobox>


                        <!-------------------------------------------------- Sucursal -->
                        <v-combobox
                            v-model="ClientesCredito.sucursal"
                            :items="RSucursal"
                            autocomplete="off"
                            dense
                            item-text="descripcion"
                            label="Sucursal:"
                            outlined
                            @blur="SelctCbSucursal"
                            @focus="cargarSucursal"

                        >
                          <template v-slot:prepend>
                            <i class="fa fa-sitemap" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>


                      </v-col>
                      <!-- fn columna 1 -->


                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">

                        <!-- -----------------------------  Hasta  -->
                        <v-text-field
                            v-model="ClientesCredito.hasta"
                            :rules="[$rules.required]"
                            dense
                            label="Hasta:"
                            outlined
                            type="date"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px;"></i>
                          </template>

                        </v-text-field>

                        <!-- ----------------------------- Tipo de Cliente -->
                        <v-combobox
                            v-model="ClientesCredito.tipocliente"
                            :items="RtipoCliente"
                            :rules="[$rules.required]"
                            autocomplete="off"
                            dense
                            item-text="descripcion"
                            label="Tipo de Cliente:"
                            outlined
                            @blur="SelctCbTipoCliente"
                            @focus="cargarTipoCliente"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-users" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                        <v-combobox
                            v-model="ClientesCredito.vendedor"
                            :items="Rvendedor"
                            autocomplete="off"
                            dense
                            item-text="nombre"

                            label=" Vendedor:"
                            outlined
                            required
                            style="font-size: 13px;"
                            @blur="SelctCbvendedor"

                            @focus="CargarRvendedor"


                        >
                          <template slot="item" slot-scope="item">
                            <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                            <v-col class="pa-0 ma-0 py-0 my-0" cols="12"
                                   md="12" sm="12" style="border: 1px solid #000000; font-size: 13px; ">
                              <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>Descripción:
                                {{ item.item.nombre }}</b></p>
                              <span class="pa-0 ma-0 py-0 my-0">
  <span class="pe-1" style="border: 1px dashed  #616161;"><b>Cedula.: </b> {{ item.item.cedula }} </span>
   <span class="pe-1" style="border: 1px dashed  #616161;"><b>Telefono: </b> {{ item.item.telefono }} </span>
                                <!-- <span class="pe-1" style="border: 1px dashed  #616161;"><b>Placa: </b> {{item.item.placa }} </span> -->
</span>
                            </v-col>

                          </template>

                          <template v-slot:prepend>
                            <i class="fa fa-universal-access" style="font-size: 20px;"></i>
                          </template>

                        </v-combobox>

                        <!--- Ordenador por --->
                        <div class="d-flex justify-center">
                          <v-switch v-model="ClientesCredito.showFacturasContado" class="mt-0" color="teal" hide-details
                                    inset>
                            <template v-slot:label>
                              <strong style="color: #000000">
                                Incluir facturas al contado: {{ ClientesCredito.showFacturasContado ? "Si" : "No" }}
                              </strong>
                            </template>
                          </v-switch>
                        </div>

                      </v-col>
                      <!-- fn columna 2 -->

                    </v-row>

                  </v-form>
                </v-container>

                <hr>

                <ModalReporteFiltros
                    :Datos="ClientesCredito"
                    @DataReporteBasico="DDataReporteBasico"
                />

              </v-card>
            </v-container>
            <!-- fn Formulario-Facturas a Creditos por Clientes -->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height-96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">

            <!--
                    <BarraBusqueda2
                          :url="$hostname + $hName + '/services/caja/findAll'"
                          :nombre="'Cajas'"
                          :headers="headers"
                          :slotname="'item.descripcion'"
                          :emitnombre="'emitCaja'"
                          :slotlist="slotlist"
                          :SeachNombre="'Búsqueda por descripción caja'"
                        /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->


      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
        v-model="acti_tb_data"
        label="myAlert"
        max-height="100%"
        max-width="100%"
        persistent
        transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn
              color="grey darken-4"
              fab
              small
              @click="acti_tb_data = !acti_tb_data"
          >
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                  v-model="search"
                  hide-details
                  label="Buscar"
                  single-line
                  @keyup="filtro"
              >
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
                :headers="slotHtabla"
                :items="list"
                :search="search"
                dense
                @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!------------otras funciones---------------->
    <v-snackbar
        v-model="aalert.estado"
        :color="aalert.color"
        :timeout="120000"
        :vertical="true"
        style="margin-top: 20%;"
        top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import {EventBus} from "../../event-bus"
import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
import ContenidoBase from "../../components/ContenidoBase"
import ModalReporteFiltros from "../../components/ModalReporteFiltros"
import {
  currencyFormatter,
  fechaNueva,
  FormatoFecha,
  getParamFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoBasico,
  RedondeoValor,
  RedondeoValorCantRed,
} from "@/js/Funciones.js"

export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros,
  },
  created() {
    var json = {
      titulo: "Reporte de Clientes a Crédito",
      descripcion: "Imprime las Facturas Pendientes a Cobrar de Clientes.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [
        "ReporteClientesCreditoNew",
        "ReporteClientesCreditoSave",
        "ReporteClientesCreditoRemove",
        "ReporteClientesCreditoAnular",
        "ReporteClientesCreditoPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("ReporteClientesCreditoNew", this.new)
    EventBus.$on("ReporteClientesCreditoSave", this.save)
    EventBus.$on("ReporteClientesCreditoRemove", this.remove)
    EventBus.$on("ReporteClientesCreditoAnular", this.remove)
    EventBus.$on("ReporteClientesCreditoPrintList", this.imprimirList)
    EventBus.$on("emitReporteClientesCredito", this.datostabla)
    EventBus.$on("onResize", this.onResize)
  },

  data: () => ({

    windowSize: {width: "auto", height: "auto"},

    RtipoCliente: [],
    Rcliente: [],
    RSucursal: [],
    Rvendedor: [],
    ClientesCredito: {
      nombre: "Facturas por Clientes",
      UrlImprimir: "/reportescxc/imprimirFacturasPorClientes",
      UrlExel: "/reportescxc/excelFacturasPorClientes",
      UrlCorreo: "/reportescxc/CorreoFacturasCrCli",
      desde: fechaNueva(),
      hasta: fechaNueva(),
      tipocliente: null,
      sucursal: null,
      vendedor: null,
      cliente: null,
      showFacturasContado: false,
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{text: "Tipo Clientes", value: "descripcion"}],

    slotlist: [
      {dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:"},
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:",
      },
      {dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo"},
    ],

    slotHtabla: [
      {text: "Código", value: "codigo"},
      {text: "Descripcion", value: "descripcion"},
    ],

    list: [],
    search: "",
    acti_tb_data: false,


    aalert: {
      estado: false,
      color: null,
    },

  }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoValor,
    RedondeoBasico,
    RedondeoValorCantRed,
    fechaNueva,
    getParamFecha,

    onResize(e) {

      console.log("imprii ")

      console.log(e)
      this.windowSize = e


    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir

    },

    datostabla(e) {

      this.ClientesCredito = e
      this.acti_tb_data = false
    },
    save() {
    },
    remove() {
    },
    eliminar() {
    },
    anular() {
    },
    imprimirList() {
    },
    // Retorna los datos del componente ModalReporteFiltros
    DDataReporteBasico() {
    },
    newwnuevo() {
      (this.ClientesCredito = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: "",
      }),
          EventBus.$emit("actualizaBarraBusqueda2")
    },


// Llamar a una API y obtener los datos.
    cargarCliente() {

      this.$axios.get(this.$hostname + this.$hName + "/clientes/findtodo/a/3/25/0", {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.Rcliente = res.data))

    },


// Comprobando si el cliente es nulo o no.
    SelctCbClient() {
      var _this = this
      setTimeout(function () {
        if (_this.ClientesCredito.cliente == null) {
          _this.ClientesCredito.cliente = ""
        }

        if (!_this.ClientesCredito.cliente.hasOwnProperty("codigo")) {
          _this.alerta("Seleccione un cliente", "error")
          _this.ClientesCredito.cliente = null
          return
        }
      }, 300)

    },

// Hacer una llamada API al servidor y devolver los datos al cliente.
    CbFilcliente(e) {
      //console.log(e.target.value)

      if (e.target.value.length >= 0) {

        this.$axios
            .get(
                this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
                "/3/25/0",
                {headers: this.$store.getters.GetheadersAxios},
            )
            .then(res => (this.Rcliente = res.data))
      }
    },


// Realizar una solicitud GET al servidor y devolver los datos al Vue HTML.
    cargarTipoCliente() {

      this.$axios.get(this.$hostname + this.$hName + "/tipoclientes/findall", {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.RtipoCliente = res.data))


    },


// Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbTipoCliente() {

      if (this.ClientesCredito.tipocliente == null) {

        this.ClientesCredito.tipocliente = ""
      }

      if (this.ClientesCredito.tipocliente.codigo == undefined) {

        this.alerta("Seleccione un tipo de cliente", "error")
        this.ClientesCredito.tipocliente = ""
        return

      }

    },


// Realizando una petición al servidor y devolviendo los datos a la variable RSucursal.
    cargarSucursal() {

      this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/", {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.RSucursal = res.data))


    },


// Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbSucursal() {

      if (this.ClientesCredito.sucursal == null) {

        this.ClientesCredito.sucursal = ""
      }

      if (this.ClientesCredito.sucursal.codigo == undefined) {

        this.alerta("Seleccione un sucursal", "error")
        this.ClientesCredito.sucursal = ""
        return

      }
    },


// Llamar a la API y obtener los datos de la API y almacenarlos en la variable Rvendedor.
    CargarRvendedor() {
      this.$axios.get(this.$hostname + this.$hName + "/vendedores/findallactiv", {headers: this.$store.getters.GetheadersAxios},
      ).then(res => {
        this.Rvendedor = res.data
      })
    },


// Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbvendedor() {

      if (this.ClientesCredito.vendedor == null) {
        this.ClientesCredito.vendedor = ""
      }

      if (this.ClientesCredito.vendedor.codigo == undefined) {
        // this.alerta("Seleccione un vendedor", "error");
        this.ClientesCredito.vendedor = ""
        return
      }

    },


    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
            (this.aalert.color = "success"),
            (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
            (this.aalert.color = "error"),
            (this.aalert.nombre = e)

        this.ejecucion = false
      }
    },


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.filtro()
    },

    async filtro() {
      await this.$axios
          .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
            usuario: JSON.parse(JSON.stringify(this.$user)),
          })
          .then(res => {
            this.list = res.data
          })
    },
  },
}
</script>

<style></style>
